import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SERVICES } from "@/lib/content";

export default function Services() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
    }
  }, [location]);

  return (
    <div className="bg-[#0a0a0a] text-white pt-32" data-testid="services-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-16">
        <div className="eyebrow mb-4">/ Services · Gros œuvre</div>
        <h1 className="font-display font-bold uppercase tracking-tighter text-5xl md:text-7xl leading-[0.92]">
          Sept spécialités.<br /><span className="text-[#ffd600]">Une exécution intégrée.</span>
        </h1>
        <p className="text-neutral-400 mt-6 text-lg max-w-3xl leading-relaxed">
          DCR-BATI prend en charge l’ensemble du gros œuvre béton armé sur vos chantiers neufs : du coffrage des voiles porteurs à la dalle de toiture, en passant par la maçonnerie traditionnelle.
        </p>
      </section>

      {SERVICES.map((svc, i) => {
        const reverse = i % 2 === 1;
        return (
          <section
            key={svc.slug}
            id={svc.slug}
            className={`relative border-t border-white/5 py-20 md:py-28 ${reverse ? "bg-[#0d0d0d]" : ""}`}
            data-testid={`service-section-${svc.slug}`}
          >
            <div className={`max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-center`}>
              <div className={`md:col-span-6 ${reverse ? "md:order-2" : ""}`}>
                <div className="relative">
                  <img src={svc.image} alt={svc.title} className="w-full h-[420px] object-cover" />
                  <div className="absolute top-4 left-4 bg-black/80 px-4 py-2 font-mono-tech text-[10px] tracking-widest uppercase border border-[#ffd600]/30">
                    / 0{i + 1} — {svc.slug}
                  </div>
                  <div className="hazard-stripes absolute -bottom-4 -left-4 w-24 h-4 hidden md:block" />
                </div>
              </div>
              <div className={`md:col-span-6 ${reverse ? "md:order-1" : ""}`}>
                <div className="flex items-center gap-3 mb-4">
                  <i className={`${svc.icon} text-[#ffd600] text-2xl`} />
                  <span className="font-mono-tech text-xs uppercase tracking-widest text-neutral-500">Service 0{i + 1}</span>
                </div>
                <h2 className="font-display uppercase font-bold tracking-tight text-3xl md:text-5xl leading-[0.95]">
                  {svc.title}
                </h2>
                <p className="text-neutral-300 mt-5 leading-relaxed">{svc.description}</p>
                <ul className="mt-7 space-y-3">
                  {svc.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-neutral-200">
                      <span className="mt-2 w-2 h-2 bg-[#ffd600] shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 flex gap-3">
                  <Link to="/devis" className="btn-primary !py-3 !px-5 text-xs">Devis pour {svc.title.split(" ")[0].toLowerCase()} <i className="fa-solid fa-arrow-right" /></Link>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      <section className="relative py-20 border-t border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <div className="eyebrow mb-3">/ Méthodologie</div>
          <h3 className="font-display uppercase font-bold tracking-tight text-3xl md:text-5xl">
            Du dossier à la <span className="text-[#ffd600]">dalle finie</span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-12">
            {[
              { n: "01", t: "Étude", d: "Analyse plans, métrés, choix techniques." },
              { n: "02", t: "Planning", d: "Phasage, ressources, sécurité." },
              { n: "03", t: "Exécution", d: "Coffrage, ferraillage, coulage." },
              { n: "04", t: "Livraison", d: "Contrôle qualité, PV de réception." },
            ].map((s) => (
              <div key={s.n} className="brut-card text-left">
                <div className="font-display text-4xl text-[#ffd600] leading-none">{s.n}</div>
                <div className="font-display uppercase mt-3 text-lg">{s.t}</div>
                <div className="text-neutral-400 text-sm mt-1">{s.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
